export const ASSIGN_TO_PRODUCT = `
  mutation AssignToProduct($input: AssignToProductInput!) {
    product {
      assignToProduct(input: $input) {
        success
        message
      }
    }
  }
`;
